export default __webpack_public_path__ + "static/media/190629_190332_IMG_3536.7ba421b1.jpg";